import { render, staticRenderFns } from "./ReturnCustomer.vue?vue&type=template&id=0527ebfe&scoped=true&lang=pug&"
import script from "./ReturnCustomer.vue?vue&type=script&lang=js&"
export * from "./ReturnCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ReturnCustomer.vue?vue&type=style&index=0&id=0527ebfe&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0527ebfe",
  null
  
)

export default component.exports